import { fetchAllTariffCatalogProducts } from 'Services/ProductManagement/Features/Product/productSlice'
import { useAppDispatch, useTypedSelector } from 'Store'
import { All_TARIFF_PRODUCTS_COUNT_PER_REQUEST } from 'Util/constants'
import { useEffect } from 'react'

function useTariffCatalogProducts(tariffId: string, catalogId: string) {
  const dispatch = useAppDispatch()
  const { allTariffCatalogProducts, allTariffCatalogProductsLoading } = useTypedSelector(
    state => state.product
  )

  const fetchAllTariffCatalogProductsWithoutPagination = () => {
    dispatch(
      fetchAllTariffCatalogProducts({
        in_tariff: tariffId,
        in_catalog: catalogId,
        bypass_pagination: true,
        count: All_TARIFF_PRODUCTS_COUNT_PER_REQUEST
      })
    )
  }

  useEffect(() => {
    fetchAllTariffCatalogProductsWithoutPagination()
  }, [])

  return {
    allTariffCatalogProducts,
    allTariffCatalogProductsLoading,
    fetchAllTariffCatalogProductsWithoutPagination
  }
}

export default useTariffCatalogProducts
